/**
 * @generated SignedSource<<2669cfe198192fd38a2111321126214c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsHeroStatusProgressBar_rewards$data = {
  readonly currentProgram: {
    readonly programInfo: {
      readonly code: string | null;
    } | null;
  } | null;
  readonly currentYearSpend: {
    readonly amount: number | null;
  } | null;
  readonly pointsNeededToLevelUp: string | null;
  readonly pointsToMaintainStatus: number | null;
  readonly " $fragmentType": "TradeBenefitsHeroStatusProgressBar_rewards";
};
export type TradeBenefitsHeroStatusProgressBar_rewards$key = {
  readonly " $data"?: TradeBenefitsHeroStatusProgressBar_rewards$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatusProgressBar_rewards">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsHeroStatusProgressBar_rewards",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pointsToMaintainStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "currentYearSpend",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pointsNeededToLevelUp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParentProgram",
      "kind": "LinkedField",
      "name": "currentProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "programInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmRewards",
  "abstractKey": null
};

(node as any).hash = "c886e9eba96ab716cc8b198b7761bafb";

export default node;
